import React from 'react';
import {
	Card,
	CardContent,
	Typography,
	Grid,
	List,
	ListItem,
	ListItemText,
	makeStyles,
	Chip
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	card: {
		marginBottom: theme.spacing(2),
	},
	metricItem: {
		textAlign: 'center',
		padding: theme.spacing(1),
	},
	metricValue: {
		fontSize: '1.5rem',
		fontWeight: 'bold',
		color: theme.palette.primary.main,
	},
	metricLabel: {
		fontSize: '0.875rem',
		color: theme.palette.text.secondary,
	},
	wordChip: {
		margin: theme.spacing(0.5),
	},
	languageChip: {
		marginTop: theme.spacing(1),
	},
}));

const ContentAnalysis = ({ contentAnalysis }) => {
	const classes = useStyles();

	if (!contentAnalysis) {
		return null;
	}

	return (
		<Card className={classes.card}>
			<CardContent>
				<Typography variant="h6" gutterBottom>
					Content Analysis
				</Typography>
				
				{/* Language Detection */}
				<Chip
					label={`Language: ${contentAnalysis.detectedLanguage || 'Unknown'}`}
					color="secondary"
					variant="outlined"
					className={classes.languageChip}
				/>
				
				<Grid container spacing={2} style={{ marginTop: 16 }}>
					<Grid item xs={6} sm={3}>
						<div className={classes.metricItem}>
							<Typography className={classes.metricValue}>
								{contentAnalysis.totalWordCount?.toLocaleString() || 0}
							</Typography>
							<Typography className={classes.metricLabel}>
								Total Words
							</Typography>
						</div>
					</Grid>
					
					<Grid item xs={6} sm={3}>
						<div className={classes.metricItem}>
							<Typography className={classes.metricValue}>
								{contentAnalysis.totalUniqueWordCount?.toLocaleString() || 0}
							</Typography>
							<Typography className={classes.metricLabel}>
								Unique Words
							</Typography>
						</div>
					</Grid>
					
					<Grid item xs={6} sm={3}>
						<div className={classes.metricItem}>
							<Typography className={classes.metricValue}>
								{contentAnalysis.totalCharacterCount?.toLocaleString() || 0}
							</Typography>
							<Typography className={classes.metricLabel}>
								Characters
							</Typography>
						</div>
					</Grid>
					
					<Grid item xs={6} sm={3}>
						<div className={classes.metricItem}>
							<Typography className={classes.metricValue}>
								{contentAnalysis.averageWordLength || 0}
							</Typography>
							<Typography className={classes.metricLabel}>
								Avg Word Length
							</Typography>
						</div>
					</Grid>
				</Grid>

				{/* Most Common Words */}
				{contentAnalysis.mostCommonWords && contentAnalysis.mostCommonWords.length > 0 && (
					<div style={{ marginTop: 24 }}>
						<Typography variant="subtitle1" gutterBottom>
							Most Common Words
						</Typography>
						<div>
							{contentAnalysis.mostCommonWords.slice(0, 20).map((word, index) => (
								<Chip
									key={index}
									label={`${word.word} (${word.count})`}
									size="small"
									variant="outlined"
									className={classes.wordChip}
								/>
							))}
						</div>
					</div>
				)}
			</CardContent>
		</Card>
	);
};

export default ContentAnalysis;
